import type {
  PaymentDetailDTO,
  PaymentDTO,
  PaymentSummaryDTO,
} from "@/modules/payments/domain/contracts";
import type {
  OffsetPageDTO,
  OffsetPageQueryDTO,
} from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type { PaymentDetailDTO, PaymentDTO, PaymentSummaryDTO };

export const paymentsApi = {
  async list(query: OffsetPageQueryDTO): Promise<OffsetPageDTO<PaymentDTO>> {
    const url = new URL(`${config.apiUrl}/payments`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<OffsetPageDTO<PaymentDTO>>(url.toString());
  },

  async get(id: string): Promise<PaymentDetailDTO> {
    return fetcher.get<PaymentDetailDTO>(`${config.apiUrl}/payments/${id}`);
  },

  async getSummary(): Promise<PaymentSummaryDTO> {
    return fetcher.get<PaymentSummaryDTO>(`${config.apiUrl}/payments/summary`);
  },

  async recordRefund(
    id: string,
    body: {
      amount: number;
      note?: string | null;
      externalId?: string | null;
      idempotencyKey?: string | null;
    },
  ): Promise<PaymentDetailDTO> {
    return fetcher.post<PaymentDetailDTO>(
      `${config.apiUrl}/payments/${id}/refunds`,
      body,
    );
  },
};
